import React from 'react';
import { injectIntl } from 'react-intl';
import { Form } from '@ant-design/compatible';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { getFields, getJobMessages } from '../../../../../constants/messages';
import { objectToArray } from '../../../../../utilities/util';
import CircleBadge from '../../../../GlobalComponents/CircleBadge';
import { JOBSTATUS } from '../../../constants';
import '@ant-design/compatible/assets/index.css';
const { Option } = Select;

let jobMessages = getJobMessages(),
	fieldMessages = getFields();

const messages = {
	...jobMessages,
	...fieldMessages,
};

const FormItem = Form.Item;

class Status extends React.Component {
	getIntl = (str) => this.props.intl.formatMessage({ ...messages[str] });

	buildOptions = () => {
		const { getIntl } = this;
		return objectToArray(JOBSTATUS).map((status) => (
			<Option key={status.id} value={status.id}>
				{getIntl(status.intl)} <CircleBadge color={status.iconColor} />
			</Option>
		));
	};

	render() {
		const { props, getIntl, buildOptions } = this;
		const { getFieldDecorator } = props.form;
		let options = buildOptions();
		return (
			<FormItem label={getIntl('status')}>
				{getFieldDecorator('status')(
					<Select
						className="job-full-component"
						showSearch
						allowClear
						placeholder={getIntl('status')}
						optionFilterProp="children"
						notFoundContent={getIntl('notFound')}
						dropdownMatchSelectWidth={false}
					>
						{options}
					</Select>
				)}
			</FormItem>
		);
	}
}

Status.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
};

export default injectIntl(Status);
